import { err, ok, type Result } from 'neverthrow';
import { z } from 'zod';

export const routeSummarySchema = z.object({
	distance: z.number().brand('Distance'),
	duration: z.number().brand('Duration'),
});

export interface RouteSummary extends z.infer<typeof routeSummarySchema> {}

export const parseRouteSummary = (
	data: unknown,
): Result<RouteSummary, z.ZodError> => {
	const result = routeSummarySchema.safeParse(data);
	if (result.success) {
		return ok(result.data);
	}

	return err(result.error);
};
